export class SetAuthentication {
    static readonly type = '[Authentication] Set';
    constructor(public authenticationInfo: any) { }
}

export class DeleteAuthentication {
    static readonly type = '[Authentication] Delete';
    constructor() { }
}
